// Replacement for next/image (revamp plan task 4): a plain <img>.
// `fill` mimics next/image's fill mode — the parent must be position:relative.
// Images are lazy unless `priority` is set.
import React from "react";

export default function Image({
  src,
  alt = "",
  fill = false,
  sizes,
  width,
  height,
  priority = false,
  className,
  style,
  ...rest
}) {
  const fillStyle = fill
    ? { position: "absolute", top: 0, right: 0, bottom: 0, left: 0, width: "100%", height: "100%" }
    : null;
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      loading={priority ? "eager" : "lazy"}
      fetchpriority={priority ? "high" : undefined}
      decoding="async"
      className={className}
      style={fillStyle ? { ...fillStyle, ...style } : style}
      {...rest}
    />
  );
}
